import { isStudioDesktop } from '@repo/studio-desktop-bridge/runtime'
import { ROUTES } from '../routes'

export const DESKTOP_WORKSPACE_ID = 'desktop'
export const STUDIO_AI_WORKSPACE_ID = 'studio-ai'

/**
 * Workspace switcher targets depend on the host. Web Desktop is the marketing
 * MFE at `/desktop`. Electron cannot follow that URL (it would drop the
 * bridge), so Desktop lands on `/` and Studio AI on `/studio`.
 */
export function hostWorkspaceHomeRoute(workspace: { id: string; homeRoute: string }): string {
  if (!isStudioDesktop()) {
    return workspace.homeRoute
  }

  switch (workspace.id) {
    case DESKTOP_WORKSPACE_ID: {
      return ROUTES.STUDIO.HOME
    }
    case STUDIO_AI_WORKSPACE_ID: {
      return ROUTES.STUDIO.STUDIO
    }
    default: {
      return workspace.homeRoute
    }
  }
}

/**
 * Web Desktop lives in another microfrontend, so the switcher must document-load
 * `/desktop` or Studio client-routes it and 404s. Electron Desktop is this SPA
 * at `/`, so that flag stays off.
 */
export function hostWorkspaceHardNavigation(workspace: {
  id: string
  hardNavigation?: boolean
}): boolean {
  if (isStudioDesktop() && workspace.id === DESKTOP_WORKSPACE_ID) {
    return false
  }
  return Boolean(workspace.hardNavigation)
}
